import { getUserInfo, unBindGoogleAuthenticator } from "@/apis/user";
import { useUserInfoStore } from "@/stores/userInfo";
import { Toast } from "antd-mobile";
import { useNavigate } from "react-router-dom";

export const useUnBindSetup = () => {
  const navigate = useNavigate();
  const userStore = useUserInfoStore()();

  const fetchUnBindGoogleAuthenticator = async (values: {
    safeCode: string;
  }) => {
    //     if (this.password.length !== 6) return this.$toast.fail("请输入google验证码")
    const { ok, msg } = await unBindGoogleAuthenticator({
      safeCode: values.safeCode,
    });
    if (ok) {
      Toast.show(msg);
      const response = await getUserInfo({});
      if (response.ok) {
        if (response.data) {
          userStore.setUserInfo(response.data);
        }
        navigate(-1);
      } else {
        Toast.show(msg);
      }
    }
  };
  return {
    fetchUnBindGoogleAuthenticator,
  };
};

export { };
